module.exports = __webpack_public_path__ + "static/media/Ockult_logo.f6eb8916.svg";